<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <page-header class="py-4 pb-6">
      {{ $t('ProductCenter') }}
    </page-header>
    <div class="px-1">
      <horizontal-list class="mt-4">
        <v-card
          v-for="pt in productTypes"
          :key="pt.type"
          :color="type===pt.type?'amber lighten-4 black--text':'white'"
          class="pa-4 d-flex align-center"
          elevation="0"
          @click="selectProductType(pt.type)"
        >
          <v-img
            :aspect-ratio="1"
            :src="require('@/assets/icon/'+pt.img)"
            class="mr-2"
            contain
            width="18"
          />
          <div
            :class="type===pt.type?'font-weight-black':''"
            class="text-body-1 mr-2"
          >
            {{ $t(pt.name) }}
          </div>
          <div class="text-caption text--secondary">
            {{ getTypeCount(pt.type) }} {{ $t('Pice') }}
          </div>
        </v-card>
      </horizontal-list>
    </div>
    <div>
      <loading-provider :loading="loading">
        <products-card
          :owned-products="activeProductCodeList"
          :product-list="filteredProductList"
          @selected="showProduct"
        />
      </loading-provider>
    </div>
  </div>
</template>

<script>
import ProductsCard from '@/views/SaaS/personalInfo/productsCard.vue'
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import HorizontalList from '@/views/widget/uiComponent/HorizontalList.vue'
import { loadProducts, ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import { getActiveProductCode } from '@/model/dataLayer/api/SaaS/user'
import { ProductTypes } from '@/views/SaaS/SaaSGuide'
import { mapMutations } from 'vuex'
import LoadingProvider from '@/views/widget/LoadingProvider'

export default {
  name: 'ProductCenter',
  components: {
    LoadingProvider,
    ProductsCard,
    PageHeader,
    HorizontalList
  },
  data () {
    return {
      products: [],
      activeProductCodeList: [],

      productTypes: [
        {
          type: ProductTypes.software,
          img: 'software.svg',
          name: 'SoftwareSystem'
        },
        {
          type: ProductTypes.hardware,
          img: 'device.svg',
          name: 'HardwareEquipment'
        }, {
          type: ProductTypes.serve,
          img: 'service.svg',
          name: 'Surcharge'
        }, {
          type: ProductTypes.extraDevice,
          img: 'store.svg',
          name: 'AdditionalStore'
        }, {
          type: ProductTypes.user,
          img: 'userLicense.svg',
          name: 'AccountEligibility'
        }
      ],
      type: ProductTypes.software,

      waitForJump: false,
      loading: false,
      tab: null,

      showingProductCode: ProductCodes.inventory
    }
  },
  computed: {
    filteredProductList () {
      return this.products.filter(it => it.metadata.type === this.type)
        .filter(it => it.metadata.code !== ProductCodes.openDevice)
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    async reload () {
      this.loading = true
      this.products = (await loadProducts())
      this.selectProductType(ProductTypes.software)
      this.activeProductCodeList = await getActiveProductCode()
      this.loading = false
    },
    getTypeCount (type) {
      return this.products.filter(it => it.metadata.type === type).length
    },
    selectProductType (item) {
      this.type = item
    },
    showProduct (code) {
      this.showProductDetail({ code })
    },
    ...mapMutations(['showProductDetail'])

  }
}
</script>

<style scoped>

</style>
